<template>
<div>
   <!-- <AlertaPlano
      text="PLANO GRATUITO"
      callbackText="ASSINAR"
      :callback="() => $router.push({ path: '/assinatura/planos' })"
      :plan="true"
      :backButton="true"
      :isGame="false"
    /> -->

   <div
    class="row"
    style="height: 56vh;"
  >
    <div class="d-flex w-100 p-4" >
      <div class="card">
        <div class="row d-flex justify-content-between" style="height: 100%">
          <div
            class="col-md-5 p-3 col-sm-12 d-flex flex-column justify-content-between align-items-start user-block-image"
          >
            <div
              class="img-user"
              v-lazy="user.foto"
              :style="`background-image: url('${user.foto ? user.foto : 'https://www.ecoscorefloor.burkeind.com/images/663.jpg'}')`"
            >
              <div class="btn-change-photo"  v-if="editable">
                <input
                  @change="(e) => changePhoto(e)"
                  style="display: none"
                  id="file-input"
                  type="file"
                />
                <label for="file-input">
                  <i class="fa fa-camera"></i>
                </label>
              </div>
            </div>
            <!-- <button
              v-if="user.ultimo_jogo && editable"
              @click="
                () => $router.push({ path: `jogo/${user.ultimo_jogo.id}/comentario/` })
              "
              class="btn-profile green last-game"
            >
              VOLTAR A JOGAR
              {{ user.ultimo_jogo ? user.ultimo_jogo.titulo : "" }}
            </button> -->
          </div>
          <div class="col-md-5 p-0 col-sm-12 offset-md-1">
            <div id="comentarios" class="comentarios ">
              <button
                @click="toogleComments"
                class="btn-profile purple btn-close-comments"
              >
                FECHAR COMENTARIOS
              </button>

              <div v-if="comentarios.length > 0" class="lista" @scroll="(e) => pagination(e)">
                <template v-for="comentario in comentarios">
                  <div
                    :key="comentario.id"
                    class="card-comentario animate__bounceIn"
                  >
                    <div
                      class="user-foto"
                      @click="
                        () =>
                          $router.push({
                            path: `/perfil/${comentario.autor_id}`,
                          })
                      "
                      :style="`background-image: url('${comentario.autor.foto}')`"
                    ></div>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span class="name"
                        >{{ comentario.autor.name }}
                        {{ comentario.autor.sobrenome }}
                      </span>

                      <div style="font-size: 12px">
                        <i class="fa fa-clock-o mr-2"></i>
                        <span class="message">{{
                          comentario.tempo_passado
                        }}</span>
                      </div>
                    </div>
                    <p class="message">{{ comentario.comentario }}</p>
                    <hr />
                    <span class="likes">
                      {{
                        comentario.created_at.split(" ")[0].split("-")[2] +
                        "/" +
                        comentario.created_at.split(" ")[0].split("-")[1] +
                        "/" +
                        comentario.created_at.split(" ")[0].split("-")[0]
                      }}</span
                    >
                  </div>
                </template>
              </div>
              <div class="p-3" v-else>
                <span class="card animate__bounceIn p-3">Seja o primeiro a comentar.</span>
              </div>

              <div class="input-comentarios">
                <div class="input-label">
                  <label class="pl-3">COMENTARIO</label>
                  <textarea
                    v-model="temp_comentario"
                    placeholder="Insira um comentario aqui"
                    @click="pause = true"
                  >
                  </textarea>
                </div>
                <button @click="comentar" class="btn-comentar py-3">
                  COMENTAR
                </button>
              </div>
            </div>
            <div class="py-4 mx-3">
              <div>
                <span v-if="!edit.name" class="name"
                  >{{ user.name ? user.name : 'Usuário' }}<br />
                  {{ user.sobrenome }}
                  <i
                    @click="toogleEdit('name')"
                    v-if="editable"
                    class="fa fa-pencil-square-o"
                    style="font-size: 20px"
                  ></i>
                </span>
                <div v-else>
                  <div class="row">
                    <div class="col-md-6">
                      <Input
                        title="Nome"
                        placeholder="Nome"
                        @blur="openDialog('name')"
                        v-model="user.name"
                      />
                    </div>
                    <div class="col-md-6">
                      <Input
                        title="Sobrenome"
                        placeholder="Sobrenome"
                        @blur="openDialog('sobrenome')"
                        v-model="user.sobrenome"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-3 location d-flex justify-content-between">
                <div v-if="!edit.cidade">
                  <i class="fa fa-map-marker"></i
                  ><span class="ml-2">{{
                    user.cidade ? user.cidade : "Não cadastrado"
                  }}</span
                  ><i
                    @click="toogleEdit('cidade')"
                    v-if="editable"
                    class="fa fa-pencil-square-o ml-2"
                    style="font-size: 15px"
                  ></i>
                </div>
                <div v-else>
                  <Input
                    title="Cidade"
                    placeholder="Cidade"
                    @blur="openDialog('cidade')"
                    v-model="user.cidade"
                  />
                </div>
                <div class="mr-2">
                  <span class="ml-2">@{{ user.sobrenome }}</span>
                </div>
              </div>
              <div class="description mt-2 mb-2" v-if="!edit.descricao">
                  <i
                  @click="toogleEdit('descricao')"
                  v-if="editable"
                  class="fa fa-pencil-square-o ml-2"
                  style="font-size: 15px; position: absolute; right: 20px"
                ></i>
                  <p>
                {{ user.descricao ? user.descricao : "..." }}
              
              </p>
              </div>
            
              <div v-else>
                <Input
                  title="Descrição"
                  placeholder="Descrição"
                  @blur="openDialog('descricao')"
                  v-model="user.descricao"
                />
              </div>
              <hr class="mt-3" />
              <!-- <div class="infos d-flex justify-content-between ">
                <div class="item d-flex flex-column align-items-center">
                  <span>COMENTÁRIOS</span>
                  <span class="number">{{ user.comentarios_count }}</span>
                </div>
                <div class="item d-flex flex-column align-items-center">
                  <span>JOGOS</span>
                  <span class="number">{{ user.jogos_count }}</span>
                </div>
                <div class="item d-flex flex-column align-items-center">
                  <span>CURTIDAS</span>
                  <span class="number">{{ user.curtidas_count }}</span>
                </div>
              </div> -->
            </div>
            <!-- <button
              @click="toogleComments"
              class="btn-profile purple btn-comentarios"
            >
              VER COMENTÁRIOS
            </button> -->
          </div>
        </div>

        <div @click="logout" v-if="editable" class="badge red">
          <i class="fa fa-sign-out"></i>
        </div>
      </div>
    </div>
    
  </div>
  <!-- <AlertaPlano text="VEJA AS NOVIDADES!" />
    <div>
      <SliderBottom />
    </div> -->
</div>
 
  
</template>
<script>
import decode from "jwt-decode";
import Input from "../components/Input";
// import AlertaPlano from "../components/AlertaPlano"
// import SliderBottom from "../components/SliderBottom"

export default {
  name: "Perfil",
  components: {
    Input,
    // AlertaPlano,
    // SliderBottom
  },
  data: () => ({
    user: {},
    id: "",
    editable: false,
    edit: {
      name: false,
      cidade: false,
      estado: false,
      descricao: false,
    },
    temp_comentario: "",
    comentarios: [],
    next_page_url: null,
    items_slider: [],
  }),
  mounted: async function(){
    this.analyticSubmit();
  },
  async created() {
    this.$store.commit("loading", true);
    this.$store.commit("jogo", false);

    if (await this.getId()) {
      if(this.id == decode(localStorage.getItem('t')).usr.id){
        this.editable = true;
      }
      await this.$axios
        .all([
          this.$axios.get(`jogo/perfil_publico/${this.id}`)
        ])
        .then(
          this.$axios.spread(
            async (perfilRes) => {
              this.user = perfilRes.data
              console.log("DADOS DO USUARIO")
              console.log(this.user)
              if(this.user.foto){
              await this.$store.commit("loading", false);
              }
            }
          )
        )
        .catch(() => {
          this.$store.commit("loading", false);
        });

    }
    this.next_page_url = `/comentarios/usuarios/${this.id}`;

  },
  methods: {
    toogleEdit: function (param) {
      this.edit[param] = !this.edit[param];
    },
    changeInfo: function (param) {
     
      this.$store.commit("loading", true);
      let payload = {
        [param]: this.user[param]
      }
      this.$axios
        .post(`edit_users/${this.id}`, payload)
        .then((res) => res.data)
        .then(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "Sucesso",
            type: "success",
            message: `${param} alterada com sucesso!`,
          });
        })
        .catch(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "error",
            message: "Erro ao subir imagem!",
          });
        });

         if(param == "sobrenome"){
        this.toogleEdit('name')
      }else{
        this.toogleEdit(param)
      }
    },
    openDialog(type){
      this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: `Você desejar salvar as informações de ${type}`,
            callbackOk: () => this.changeInfo(type),

        });
        
    },
    comentar: function () {
       if(localStorage.getItem('t')){
      this.$axios
        .post(`comentarios`, {
          destino_usuario_id: this.id,
          comentario: this.temp_comentario,
        })
        .then((res) => res.data)
        .then((res) => {
          try{
            document.getElementsByClassName('lista')[0].scrollTop = '0px'
          }catch(e){
            console.log('err', e)
          }
          if(this.comentarios.length > 0){
            this.comentarios.unshift(res);
          }else{
            this.comentarios.push(res);
          }
          
          this.temp_comentario = "";
        })
        .catch(() => {
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "error",
            message: "Erro ao comentar!",
          });
        });
       }else{
         this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "warning",
            message: "Faça login para comentar!",
        });
        this.$router.push({path: '/login'})
       }
    },
    changePhoto: function (e) {
      let user = { ...this.user };
      let objRequest = new FormData();
      this.$store.commit("loading", true);
      user = {
        id: this.user.id,
        foto: e.target.files[0],
      };
      for (let item in user) {
        user[item] = objRequest.append(item, user[item]);
      }
      this.$axios
        .post(`edit_users/${this.id}`, objRequest)
        .then((res) => res.data)
        .then((res) => {
          console.log(res);
          this.user.foto = URL.createObjectURL(e.target.files[0]);
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "Sucesso",
            type: "success",
            message: "Imagem alterada com sucesso!",
          });
        })
        .catch(() => {
          this.$store.commit("loading", false);
          this.$store.commit("setStateModal", {
            visible: true,
            title: "ATENÇÃO",
            type: "error",
            message: "Erro ao subir imagem!",
          });
        });
    },
    getId: async function () {
      if (this.$route.params.id) {
        this.id = this.$route.params.id;
        return true;
      } else {
        if (localStorage.getItem("t")) {
          this.id = decode(localStorage.getItem("t")).usr.id;
          return true;
        } else {
                      await this.$store.commit("loading", false);

          await this.$store.commit("setStateModal", {
            visible: true,
            title: "Atenção!",
            type: "warning",
            message: "Faça login para continuar.",
          });
          await this.$router.push({
            path: "/login",
          });
          return false;
        }
      }
    },
    pagination: function (e) {
      if (e.target.scrollTop + e.target.clientHeight == e.target.scrollHeight) {
        this.getComments(this.next_page_url);
      }
    },
    getComments: function (url) {
      if (url != null) {
        this.$axios
          .get(url)
          .then((res) => res.data)
          .then((res) => {
            let comentarios = [...res.data]
            comentarios = comentarios.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
            this.comentarios.push(...comentarios);
            this.next_page_url = res.next_page_url;
          });
      }
    },
    logout: async function() {
      await this.$store.commit("setStateModal", {
            visible: true,
            title: "Volte sempre!",
            type: "warning",
            message: "Já vai? Volte sempre, estaremos esperando por você!",
            callbackOk: async () => {
              await this.$store.commit("loading", true)
              await localStorage.removeItem('t')
              localStorage.removeItem("typeOfUser");
              this.$intercom.shutdown();
              await this.$store.commit("logado", false)
              await this.$router.replace({path: "/", force: true});
              await this.$store.commit("loading", false)
            },
            callbackCancel: () => this.$store.commit("setStateModal", {visible:false})
          });



    },
    toogleComments: function () {
      if (document.getElementById("comentarios").classList.contains("active")) {
        document.getElementById("comentarios").classList.remove("active");
      } else {
        document.getElementById("comentarios").classList.add("active");
        this.getComments(this.next_page_url);
      }
    },
    cancelarAssinatura() {
      this.$store.commit("setStateModal", {
        visible: true,
        title: "ATENÇÃO",
        type: "warning",
        message: "Deseja realmente cancelar seu plano?",
        callbackCancel: () => console.log("Cancelou"),
        callbackOk: () => {
          try {
            this.$store.commit("loading", true);
            let user_id = decode(localStorage.getItem("t")).usr.id;
            let assinatura_id = "";
            let assinatura_backend_php_id = "";
            let plano_gratuito_id = 4;
            let customer_id = decode(localStorage.getItem("t")).usr.stripe_id;
            this.$axios
              .get(`/users/${user_id}/assinaturas`)
              .then((res) => res.data)
              .then((res) => {
                let plano_id = res[0].planos_id;

                if (plano_id == 4) {
                  this.$store.commit("setStateModal", {
                    visible: true,
                    title: "Erro!",
                    type: "warning",
                    message: "Você não possui uma assinatura paga.",
                  });
                } else if (plano_id == 7) {
                  this.$axios
                    .get(`users/${user_id}/assinaturas`)
                    .then((res) => {
                      assinatura_backend_php_id = res.data[0].id;
                      console.log(res);

                      this.$axios
                        .delete(`assinaturas/${assinatura_backend_php_id}`)
                        .then((res) => res.data)
                        .then((res) => {
                          console.log(res);
                          this.$axios
                            .post("checkout", {
                              meio_de_pagamento: "boleto",
                              planos_id: plano_gratuito_id,
                            })
                            .then((res) => res.data)
                            .then((res) => {
                              console.log(res);

                              this.$store.commit("setStateModal", {
                                visible: true,
                                title: "Sucesso!",
                                type: "success",
                                message:
                                  "Seu plano foi cancelado com sucesso, você voltou a ser um assinante do plano gratuito.",
                              });
                            })
                            .catch((err) => {
                              console.log(err + " Erro");

                              this.$store.commit("setStateModal", {
                                visible: true,
                                title: "Erro!",
                                type: "warning",
                                message:
                                  "Não foi possível cancelar sua assinatura.",
                              });
                            });
                        });
                    });
                } else if (plano_id == 12) {
                  console.log("customer id = " + customer_id);
                  this.$axios
                    .get(
                      "https://api2.arecreativa.com.br/show_customer_subscription",
                      {
                        customer_id,
                      }
                    )
                    .then((res) => {
                      console.log(res.data);
                      assinatura_id = res.data.data[0].id;

                      this.$axios
                        .post(
                          "https://api2.arecreativa.com.br/delete_subscription",
                          {
                            subscription_id: assinatura_id,
                          }
                        )
                        .then((res) => {
                          console.log(res);
                          this.$axios
                            .get(`users/${user_id}/assinaturas`)
                            .then((res) => {
                              assinatura_backend_php_id = res.data[0].id;

                              this.$axios
                                .delete(
                                  `assinaturas/${assinatura_backend_php_id}`
                                )
                                .then((res) => {
                                  console.log(res);
                                  this.$axios
                                    .post("checkout", {
                                      meio_de_pagamento: "boleto",
                                      planos_id: plano_gratuito_id,
                                    })
                                    .then((res) => res.data)
                                    .then((res) => {
                                      console.log(res);

                                      this.$store.commit("setStateModal", {
                                        visible: true,
                                        title: "Sucesso!",
                                        type: "success",
                                        message:
                                          "Seu plano foi cancelado com sucesso, você voltou a ser um assinante do plano gratuito.",
                                      });
                                      this.$router.replace({
                                        path: "/",
                                        force: true,
                                      });
                                    })
                                    .catch((err) => {
                                      this.$store.commit("loading", false);
                                      console.log(err + " Erro");

                                      this.$store.commit("setStateModal", {
                                        visible: true,
                                        title: "Atenção!",
                                        type: "warning",
                                        message:
                                          "Não foi possível cancelar sua assinatura.",
                                      });
                                    });
                                })
                                .catch((err) => {
                                  console.log(err + " Erro");
                                  this.$store.commit("setStateModal", {
                                    visible: true,
                                    title: "Atenção!",
                                    type: "warning",
                                    message:
                                      "Não foi possível cancelar sua assinatura.",
                                  });
                                });
                            })
                            .catch((err) => {
                              console.log(err + " Erro");
                              this.$store.commit("setStateModal", {
                                visible: true,
                                title: "Atenção!",
                                type: "warning",
                                message:
                                  "Não foi possível cancelar sua assinatura.",
                              });
                            });
                        })
                        .catch((err) => {
                          console.log(err + " Erro");
                          this.$store.commit("setStateModal", {
                            visible: true,
                            title: "Atenção!",
                            type: "warning",
                            message:
                              "Não foi possível cancelar sua assinatura.",
                          });
                        });
                    })
                    .catch((err) => {
                      console.log(err + " Erro");
                      this.$store.commit("setStateModal", {
                        visible: true,
                        title: "Atenção!",
                        type: "warning",
                        message: "Não foi possível cancelar sua assinatura.",
                      });
                    });
                } else {
                  console.log(plano_id);
                  this.$store.commit("setStateModal", {
                    visible: true,
                    title: "Erro!",
                    type: "warning",
                    message: "Não foi possível cancelar sua assinatura.",
                  });
                }
              })
              .catch((err) => {
                this.$store.commit("setStateModal", {
                  visible: true,
                  title: "ATENÇÃO",
                  type: "warning",
                  message: err.response.data.message,
                });
              });
          } catch (error) {
            this.$store.commit("setStateModal", {
              visible: true,
              title: "Erro!",
              type: "warning",
              message: "Não foi possível cancelar sua assinatura!",
            });
          }
          this.$store.commit("loading", false);
        },
      });
    },
    analyticSubmit: function(){
      try {
        this.$intercom.trackEvent("WEB_tela_perfil");
      } catch (error) {
        console.log("analytycIntercom perfil error:", error)
      }
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap");
.card {
  border: none;
  box-shadow: 10px 10px 50px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  font-size: 14px !important;
  width: 100%;
  font-weight: bold;
}

.infos{
  font-size: 15px;
  margin-bottom: 30px;
  letter-spacing: 2px;
}

.infos .number{
    font-family: "Roboto", sans-serif !important;
}

.user-block-image{
  box-shadow: 10px 0px 10px rgba(0, 0, 0, 0.100);
}
.card-comentario {
  padding: 5px 0px 15px 65px;
  width: 95%;
  box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.2);
  margin: 5px 0px;
  background-color: white;
  position: relative;
}
.btn-close-comments {
  position: absolute;
  height: 40px;
  z-index: 9999;
  top: 0;
}
.card-comentario .user-foto {
  width: 50px;
  height: 50px;
  background-size: cover;
  position: absolute;
  left: 0;
  top: 0;
}

.active {
  height: 100% !important;
  padding-top: 40px;
}

.description {
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  line-height: 14px;
  height: 30px;
  font-weight: 500;
  overflow-y: auto;
  word-break: break-word;
}

.description p{
  font-family: "Roboto", sans-serif;
  font-size: 12px;
  word-break: break-word;
}

.description::-webkit-scrollbar {
  display: none;
}

.comentarios {
  width: 100%;
  height: 0%;
  background-color: rgb(189, 189, 189);
  position: absolute;
  z-index: 9999;
  right: 0px;
  transition: ease 2s;
  bottom: 0;
  
  overflow-y: auto;
}

.lista {
  overflow-y: scroll;
  width: 100%;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: center;
  padding-bottom: 120px;
}

.lista::-webkit-scrollbar {
  display: none;
}

.card-comentario .name {
  text-transform: capitalize;
  font-size: 1.1em;
  letter-spacing: 1px;
}

.card-comentario .likes {
  text-transform: capitalize;
  letter-spacing: 1px;
  font-size: 0.7em;
  font-family: "Agency FB Regular";
}

.card-comentario .message {
  font-size: 0.8em;
  margin-top: 10px;
  opacity: 0.8;
  letter-spacing: 1px;
  font-family: "Agency FB Regular";
  word-break: break-word;
  padding-right: 10px;
}

.card-comentario .user-foto {
  width: 50px;
  height: 50px;
  background-size: cover;
  position: absolute;
  background-position: center center;
  left: 0;
  top: 0;
  cursor: pointer;
}

.w-80 {
  width: 80%;
}

.w-90 {
  width: 85%;
}

.badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  border-radius: 0;
  align-items: center;
  font-size: 20px;
  color: white;
}

.img-user {
  width: 100%;
  background-size: cover;
  background-position: center;
  height: 80%;
  position: relative;
  cursor: pointer;
}

.btn-change-photo {
  position: absolute;
  bottom: 0;
  right: 0px;
  font-size: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  width: 40px;
  height: 40px;
  font-weight: bold;
}

.btn-change-photo i {
  cursor: pointer;
  text-shadow: 0px 0px 10px black;
}

hr{
  height: 1px;
  background-color: black;
  opacity: .1;
}

.name {
  font-size: 40px;
  line-height: 40px;
  letter-spacing: 5px;
  text-transform: uppercase;
}

.btn-profile {
  width: 100%;
  border-radius: 0;
  color: white;
  padding: 10px 0px;
  outline: 0;
  position: absolute;
  bottom: 0;
  font-size: 18px;
  left: 0;
  border: none;
  letter-spacing: 2px;
}

.purple {
  background-color: #8d4d9a;
  outline: 0;
  font-weight: bold;

}

.red{
  background-color: #9a4d4d;
  outline: 0;
  cursor: pointer;
    font-weight: bold;

}

.green {
  background-color: #569a4d;
    font-weight: bold;

  text-transform: uppercase;
}

.location span {
  font-family: "Agency FB Regular";
  opacity: 0.4;
  font-size: 12px;
  letter-spacing: 2px;
}

.number {
  font-family: "Agency FB";
  letter-spacing: 2px;
}

.input-comentarios {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  display: flex;
  background-color: white;
  padding-top: 10px;
  flex-direction: column;
  box-shadow: -1px 0px 20px rgba(0, 0, 0, 0.233);
}

.input-comentarios button {
  margin: 0;
  width: 100%;
  height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: #8d4d9a;
  color: white;
  letter-spacing: 2px;
}

.input-comentarios .input-label {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.input-comentarios .input-label textarea {
  height: 40px;
  border: none;
  outline: 0;
  padding-left: 15px;
  font-family: "Agency FB Regular";
}

.btn-next {
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  color: black;
  font-size: 30px;
  color: black;
  outline: 0;
  z-index: 9999;
  border: none;
}

.btn-prev {
  position: absolute;
  top: calc(50% - 15px);
  left: 20px;
  color: black;
  font-size: 30px;
  z-index: 99999;
  color: black;
  outline: 0;
  border: none;
}

</style>